import React from 'react';
import { BaseFeedEditorHotspotProps } from '@go-client/lib/feedEditor';
import { FeedEditorHotspot } from '@go-client/components';
import { FeedArea } from '@go-shared/types/feedTemplate';
import { ObjectId } from 'bson';
import { BareContentTemplateLegacy } from '@go-shared/types/contentTemplate';

export const ItineraryWidgetHotspot: React.FC<BaseFeedEditorHotspotProps> = ({
  area,
  contentTemplate,
  onDrop,
  selectedLanguage,
  showMergedVars,
  highlightAreas,
  editorLocked,
  mcmKey,
}) => {
  return (
    <div className="relative w-full">
      <FeedEditorHotspot
        onElementCreated={() => null}
        onElementChanged={() => null}
        onColumnCreated={() => null}
        onRowMove={() => null}
        onRowCreated={() => null}
        onContentChange={() => null}
        onAreaDeleted={() => null}
        contentTemplate={contentTemplate}
        key={area.content!._id}
        area={area}
        onDrop={onDrop}
        selectedLanguage={selectedLanguage}
        showMergedVars={showMergedVars}
        highlightAreas={highlightAreas}
        editorLocked={editorLocked}
        mcmKey={mcmKey}
      />
    </div>
  );
};

export const generateItineraryWidgetArea = (ct: BareContentTemplateLegacy): FeedArea => {
  return {
    _id: new ObjectId().toHexString(),
    rectangle: {
      x: 100,
      y: 100,
      width: 0,
      height: 0,
    },
    style: {},
    className: 'w-full',
    contentType: 'itinerary-widget',
    content: {
      _id: ct._id,
      content: ct.content,
      name: ct.name,
      property: ct.property,
    },
  };
};
